import React, {useEffect, useState, useRef} from 'react'
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import logo from '../assets/images/MGL.png'
import {useForm} from "react-hook-form";
import axios from 'axios';
import {toast} from 'react-toastify';
import {BASE_URL} from "../utils/commonUrl";
import {ProgressSpinner} from "primereact/progressspinner";
import { Toast } from 'primereact/toast';

const ForgetPassword = () => {
    const primeToast = useRef(null)
    const [pmsRegister, setRegister] = useState({isLoading: false, message: ''})

    const {register, formState: {errors}, handleSubmit, reset} = useForm();

    const onSubmit = data => {
        userRegister(data);
    }

    useEffect(() => {
    

    }, [])


    //const notify = (message) => toast.info(message);

    const userRegister = async (body) => {
        
        setRegister({...pmsRegister, isLoading: true})
        axios.post(BASE_URL + "/api/register/ForgetPassword", body)
                                .then(response => {
                                    setRegister({...pmsRegister, isLoading: false})
                                    if (response.status === 200) {
                                        var data = response.data;
                                        if(data[0].status === "Done"){
                                            reset()
                                            primeToast.current.show({ 
                                                severity: 'success', 
                                                summary: 'Success', 
                                                detail: 'Your Password has been reset. Check your email '+data[0].email, 
                                                life: 3000 });      
                                        }
                                        else if(data[0].status === "Incorrect Email"){
                                            reset()
                                            primeToast.current.show({ 
                                                severity: 'info', 
                                                summary: 'Incorrect Email', 
                                                detail: "Your email is incorrect..! Update your email "+data[0].email, 
                                                life: 3000 });      
                                        }
                                        else if(data[0].status === "User Not Found"){
                                            primeToast.current.show({ 
                                                severity: 'warn', 
                                                summary: 'User Not Found', 
                                                detail: "Your user not found in PMS..!", 
                                                life: 3000 });      
                                        }                                  
                                    }
                                    else{
                                        primeToast.current.show({
                                            severity: 'error',
                                            summary: 'error',
                                            detail: 'Please contact with MIS team..!',
                                            life: 3000
                                        });
                                    } 
                                }).catch(e => {
                                    primeToast.current.show({
                                        severity: 'error',
                                        summary: 'error',
                                        detail: 'Please contact with MIS team..!',
                                        life: 3000
                                    });
                                })
        // const url = BASE_URL + "/api/register/ForgetPassword"
        // try {
            
        //     const response = await axios.post(url, body);
        //     reset()
        //     setRegister({...pmsRegister, isLoading: false})

        //     var data = response.data;

        //     if(data.status === "Done"){
        //         notify("Your Password has been reset. Check your email "+data.email);
        //     }
        //     else if(data.status === "Incorrect Email"){
        //         notify("Your email is incorrect..! Update your email "+data.email);
        //     }
        //     else if(data.status === "User Not Found"){
        //         notify("Your user not found in PMS..!");
        //     }
            
        // } catch (e) {
        //    if (e.response.status === 400){
        //        notify(e.response.data.message)
        //    }
        //    else if (e.response.status === 500){
        //        notify("Something went wrong Please contact with MIS")
        //    }
        //     setRegister({...pmsRegister, isLoading: false, message: ''});

        // }

    }

    const handleChangeWhiteSpace = (e) => {
        if (e.target.value.includes(" ")) {
          e.target.value = e.target.value.replace(/\s/g, "");
        }
      };


    return (
        <div className='container'>
            <Toast ref={primeToast}/>
            <div className='row justify-content-start'>
                <div className='col-md-4  offset-md-4'>
                    <div className='login-logo mt-5 d-flex justify-content-center'>
                        <img src={logo} width="50" height="50" alt={"aaaa"}/>

                        <h1>PMS</h1>
                    </div>
                    <div className='login-logo mt-2 d-flex justify-content-center'>                        
                        <h6>Forget Password</h6>
                    </div>
                    <form method='POST' className='mt-3' onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-outline mb-3">

                            <select className="form-select" id='factoryID' name='factoryID'
                                    {...register("factoryID", {required: true})}>
                                <option value="">Select Factory Name</option>
                                <option value="02">Corporate/MGL</option>
                                <option value="04">BGL</option>
                                <option value="06">TAL</option>
                                <option value="09">RHL</option>
                            </select>
                            <span
                                className='text-danger'>{errors.factoryID?.type === 'required' && "Please Select a Factory"}</span>
                        </div>

                        <div className="form-outline mb-3">
                            <input type="text" name='employeeCode'
                                   autoComplete="off"
                                   placeholder='Enter Employee Code..'
                                   onKeyUp={handleChangeWhiteSpace}
                                   {...register("employeeCode", {required: true})} id="employeeCode"
                                   className="form-control"/>
                            <span
                                className='text-danger'> {errors.employeeCode?.type === 'required' && "Employee Code is Required"}</span>
                        </div>                        

                        <div className='d-flex justify-content-between'>
                            <button type="submit" className="btn btn-primary btn-block mb-4 mt-2" disabled={pmsRegister.isLoading}>
                            <i class="bi bi-key-fill"></i> Reset Password
                            </button>
                            <Link className="m-2" to={"/login"}><i class="bi bi-unlock-fill"></i> Login</Link>
                            {pmsRegister.isLoading ? <ProgressSpinner style={{height:'40px',width:'40px'}} />:""}
                        </div>


                    </form>
                </div>
            </div>

        </div>
    )
}

export default ForgetPassword